export default "__VITE_ASSET__BfBbsAAC__"